import React from 'react'
import Layout from 'components/layout'

const ConfirmSubscriptionPage = () => {
  return (
    <Layout meta={{title: 'Confirm your subscription'}}>
      <main className="flex min-h-screen flex-grow flex-col items-center justify-center p-5 text-white">
        <Image />
        <div className="max-w-lg text-center font-light">
          <h1 className="py-8 font-heading text-3xl font-bold lg:text-4xl">
            Por favor, revisa tu inbox. Te acabamos de enviar un correo.
          </h1>
          <p className="mx-auto pb-8 leading-relaxed text-gray-100 sm:text-lg">
            Deberás hacer clic en el enlace de confirmación para recibir más
            correos electrónicos. Si no ves el correo electrónico después de
            unos minutos, es posible que el correo este en tu carpeta de correo
            no deseado, agrega <strong>equipo@escuelafrontend.com</strong> a tus
            contactos.
          </p>
        </div>
      </main>
    </Layout>
  )
}

export default ConfirmSubscriptionPage

const Image = () => {
  return (
    <svg
      className="w-24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 72 77"
    >
      <path
        fill="#64748B"
        d="M36 61.042c-.292 0-.583-.081-.84-.244L.726 38.885a1.568 1.568 0 0 1 .14-2.721L36 14.086l35.134 22.076a1.568 1.568 0 0 1 .14 2.722L36.842 60.798a1.566 1.566 0 0 1-.84.244Z"
      />
      <path
        fill="url(#a)"
        d="M59.478 62.607H12.522V6.261c0-.864.702-1.565 1.566-1.565h43.825c.864 0 1.565.7 1.565 1.565v56.346Z"
      />
      <path
        fill="#7688A2"
        d="M70.434 76.694a1.61 1.61 0 0 1-.394-.05l-35.999-9.392.394-10.906L72 37.564v37.564a1.566 1.566 0 0 1-1.565 1.565Z"
      />
      <path
        fill="#8E9EB6"
        d="M70.434 76.694H1.566a1.565 1.565 0 0 1-1.565-1.566V37.564l71.183 36.19a1.566 1.566 0 0 1-.75 2.94Z"
      />
      <path
        fill="#CBD5E1"
        d="M48.522 17.217H23.48a1.565 1.565 0 1 1 0-3.13h25.043a1.565 1.565 0 1 1 0 3.13Zm-4.174 6.261H27.653c-.576 0-1.044-.7-1.044-1.565 0-.866.468-1.566 1.044-1.566h16.695c.576 0 1.044.7 1.044 1.566 0 .865-.468 1.565-1.044 1.565Z"
      />
      <rect
        width="36.223"
        height="14.087"
        x="18"
        y="29.738"
        fill="#2563EB"
        rx="7.043"
      />
      <path
        fill="#fff"
        d="M24.825 39.291c-.489 0-.908-.094-1.259-.282a1.952 1.952 0 0 1-.807-.795c-.184-.342-.276-.743-.276-1.202 0-.342.052-.653.157-.933.108-.28.263-.52.463-.72.205-.2.45-.352.739-.457a2.819 2.819 0 0 1 1.578-.093c.208.041.392.106.55.194a.54.54 0 0 1 .245.237.49.49 0 0 1 .044.295.564.564 0 0 1-.107.269.44.44 0 0 1-.225.163.417.417 0 0 1-.3-.044 1.913 1.913 0 0 0-.377-.132 1.43 1.43 0 0 0-.381-.05c-.26 0-.476.05-.651.15a.918.918 0 0 0-.389.426 1.64 1.64 0 0 0-.131.695c0 .276.044.51.131.701a.953.953 0 0 0 .389.432c.175.096.392.144.65.144.11 0 .226-.012.351-.037.125-.03.248-.073.37-.132a.509.509 0 0 1 .331-.043c.1.025.18.075.238.15a.541.541 0 0 1 .12.263.468.468 0 0 1-.045.288.482.482 0 0 1-.225.231 1.877 1.877 0 0 1-.545.207 2.78 2.78 0 0 1-.638.075Zm3.75 0c-.446 0-.839-.094-1.177-.282a2.023 2.023 0 0 1-.789-.801c-.183-.342-.275-.74-.275-1.196 0-.342.052-.653.156-.933.109-.28.261-.52.457-.72.2-.2.439-.352.714-.457.276-.108.58-.163.914-.163.447 0 .837.094 1.17.282.339.188.602.453.79.795.188.338.282.737.282 1.196 0 .342-.055.653-.163.933a2.003 2.003 0 0 1-1.165 1.19 2.56 2.56 0 0 1-.914.156Zm0-.964a.983.983 0 0 0 .564-.157.998.998 0 0 0 .357-.45c.083-.197.125-.432.125-.708 0-.413-.092-.734-.276-.964-.183-.23-.44-.344-.77-.344-.217 0-.405.052-.563.156a.958.958 0 0 0-.357.445 1.775 1.775 0 0 0-.125.707c0 .413.091.737.275.97.184.23.44.345.77.345Zm3.147.952c-.175 0-.309-.046-.4-.138-.092-.092-.138-.228-.138-.407v-3.412c0-.184.046-.324.137-.42a.47.47 0 0 1 .363-.15.56.56 0 0 1 .313.075c.076.05.16.134.251.25l1.985 2.48h-.176V35.29c0-.175.044-.308.132-.4.092-.092.225-.138.4-.138.176 0 .307.046.395.138.092.092.138.225.138.4v3.469a.561.561 0 0 1-.126.382.434.434 0 0 1-.338.138.655.655 0 0 1-.338-.076 1.288 1.288 0 0 1-.256-.25l-1.985-2.486h.175v2.267c0 .18-.046.315-.137.407-.088.092-.22.138-.395.138Zm4.475 0c-.183 0-.327-.05-.432-.15-.1-.105-.15-.253-.15-.445v-3.28c0-.193.05-.339.15-.44.105-.103.255-.156.451-.156h2.085c.15 0 .263.038.338.113.075.075.113.184.113.326a.474.474 0 0 1-.113.338c-.075.075-.188.112-.338.112h-1.534v.89h1.396c.146 0 .257.037.332.112.08.075.119.184.119.326 0 .146-.04.256-.119.331-.075.076-.186.113-.332.113h-1.396v1.215c0 .396-.19.595-.57.595Zm3.307 0c-.184 0-.326-.05-.426-.15-.1-.105-.15-.251-.15-.439v-3.35c0-.192.05-.338.15-.438.1-.1.242-.15.426-.15.187 0 .33.05.425.15.1.1.15.246.15.438v3.35c0 .188-.047.334-.143.438-.096.1-.24.15-.432.15Zm1.637 0c-.184 0-.326-.05-.426-.15-.1-.105-.15-.25-.15-.433v-3.305c0-.188.05-.332.15-.432.104-.1.248-.15.432-.15h1.54c.501 0 .887.123 1.159.369.275.242.413.58.413 1.014a1.4 1.4 0 0 1-.188.733 1.21 1.21 0 0 1-.532.475c-.23.109-.514.163-.852.163l.05-.113h.3c.18 0 .339.044.477.132a.956.956 0 0 1 .344.388l.313.563c.067.121.098.24.094.357a.376.376 0 0 1-.138.282c-.083.071-.206.107-.37.107a.73.73 0 0 1-.4-.1.883.883 0 0 1-.269-.314l-.57-1.045a.4.4 0 0 0-.194-.188.582.582 0 0 0-.263-.056h-.344v1.12c0 .184-.048.328-.144.432-.096.1-.24.15-.432.15Zm.576-2.517h.764c.22 0 .39-.044.507-.132.117-.087.175-.223.175-.407 0-.175-.058-.306-.175-.394-.117-.092-.286-.138-.507-.138h-.764v1.07Zm3.487 2.517c-.166 0-.296-.046-.388-.138-.087-.092-.131-.221-.131-.388v-3.475c0-.171.048-.3.144-.388.096-.092.231-.138.407-.138.146 0 .26.03.344.088a.721.721 0 0 1 .238.275l1.346 2.417h-.22l1.34-2.417a.798.798 0 0 1 .239-.275.623.623 0 0 1 .35-.088c.167 0 .294.046.382.138.092.087.138.217.138.388v3.475c0 .167-.044.296-.132.388-.087.092-.217.138-.388.138-.167 0-.296-.046-.388-.138-.088-.092-.131-.221-.131-.388v-2.154h.131l-1.008 1.753a.705.705 0 0 1-.188.207.426.426 0 0 1-.256.068.444.444 0 0 1-.257-.069.639.639 0 0 1-.182-.206l-1.014-1.76h.144v2.16c0 .168-.044.297-.131.389-.088.092-.217.138-.389.138Z"
      />
      <circle cx="57.913" cy="7.826" r="7.826" fill="url(#b)" />
      <path
        fill="#fff"
        d="M57.563 11.469h1.19V4.165h-.814c-.282.71-.69.907-1.753.918v.835c.47 0 .928-.021 1.377-.063v5.614Z"
      />
      <defs>
        <linearGradient
          id="a"
          x1="36"
          x2="36"
          y1="30.847"
          y2="62.607"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ECF3FF" />
          <stop offset="1" stopColor="#BECBE2" />
        </linearGradient>
        <linearGradient
          id="b"
          x1="57.913"
          x2="57.913"
          y1="0"
          y2="15.652"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF4C42" />
          <stop offset="1" stopColor="#E72C22" />
        </linearGradient>
      </defs>
    </svg>
  )
}
